import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
    IconButton,
    Paper
} from '@mui/material';
import { Close as CloseIcon, Celebration as CelebrationIcon } from '@mui/icons-material';
import logo from '../../assets/img/logo.png';

const WelcomeDialog = ({ open, onClose }) => (
    <Dialog 
        open={open} 
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
            sx: {
                borderRadius: 2,
                boxShadow: 24
            }
        }}
    >
        <DialogTitle 
            sx={{ 
                p: 3,
                pb: 0,
                '& .MuiIconButton-root': {
                    color: 'text.secondary'
                }
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                <img 
                    src={logo} 
                    alt="TTE Logo" 
                    style={{ 
                        width: '40px',
                        height: '40px'
                    }} 
                />
                <Typography variant="h5" component="span" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                    Welcome to Total Turf Experience
                </Typography>
            </Box>
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 16,
                    top: 16
                }}
            >
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 2 }}>
            {/* 2026 Announcement Banner */}
            <Paper
                elevation={0}
                sx={{
                    p: 2.5,
                    mb: 3,
                    background: 'linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)',
                    borderRadius: 2,
                    textAlign: 'center',
                    color: 'white'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 0.5 }}>
                    <CelebrationIcon />
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        2026 Administrative Fees Now Open!
                    </Typography>
                    <CelebrationIcon />
                </Box>
            </Paper>

            <Typography
                variant="body1"
                paragraph
                sx={{
                    fontSize: '1rem',
                    color: 'text.primary',
                    mb: 2
                }}
            >
                From this site, you can manage and pay your administrative fees.
            </Typography>
            <Typography
                variant="body1"
                paragraph
                sx={{
                    fontSize: '1rem',
                    color: 'text.primary',
                    mb: 2
                }}
            >
                Once you head through the checkout process, you will agree to the terms of the health waiver.
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    fontSize: '1rem',
                    color: 'text.primary',
                    fontWeight: 500,
                    mb: 2
                }}
            >
                Once paid, no further action is needed and you are ready to go! Be sure to show your <b>Entry Pass</b>, when entering the facility.
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    fontSize: '1rem',
                    color: 'text.primary',
                    fontWeight: 500
                }}
            >
                If you have any issues, please do not hesitate to give us a call.
            </Typography>
        </DialogContent>
        <DialogActions 
            sx={{ 
                px: 3, 
                pb: 3,
                pt: 1
            }}
        >
            <Button 
                onClick={onClose} 
                variant="contained" 
                color="primary"
                size="large"
                sx={{ 
                    px: 4,
                    py: 1,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontSize: '1rem'
                }}
            >
                Got it!
            </Button>
        </DialogActions>
    </Dialog>
);

export default WelcomeDialog; 